import { Typography } from "@/components";
import { NavigationBack } from "@/components/navigation";
import { CalendarRootPageSearchSchema } from "@/schemas";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import EventForm from "../-components/EventForm";

export const Route = createFileRoute("/dashboard/calendar/events/create")({
	validateSearch: zodSearchValidator(CalendarRootPageSearchSchema),
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<AppBar
				position="relative"
				color="transparent"
				className="[&_*_]:text-white !bg-gradient-case !relative !z-[9999]"
			>
				<div className="container">
					<Toolbar classes={{ root: "!p-0" }}>
						<NavigationBack />
						<Typography fontWeight={700} fontSize={16}>
							Add Event
						</Typography>
					</Toolbar>
				</div>
			</AppBar>
			<div className="flex-1 flex flex-col bg-gray-light">
				<EventForm />
			</div>
		</>
	);
}
